import React from 'react';

export default function AboutPage() {
  return (
    <>
      <div className="page-header">
        <span className="badge">About Us</span>
        <h1>3D Fila Space</h1>
        <p>Built by makers, for makers — bringing digital designs into the physical world, one layer at a time.</p>
      </div>

      <div className="about-page">
        <section className="about-section">
          <h2>Our Story</h2>
          <p>
            3D Fila Space started as a small workshop experiment: could we take
            the same complex, high-detail 3D models used in games and design
            studios, and turn them into physical, collectible prints anyone
            could own? What began with a single printer and a handful of test
            models has grown into a full catalog of engineered, print-ready
            designs.
          </p>
        </section>

        <section className="about-section">
          <div className="mission-vision-grid">
            <div className="mv-card hud-frame">
              <h3>Mission</h3>
              <p>
                Make high-quality, precisely engineered 3D prints accessible
                to everyone — no printer, no software, no learning curve
                required. Just pick a model, pick a color, and we handle the rest.
              </p>
            </div>
            <div className="mv-card hud-frame">
              <h3>Vision</h3>
              <p>
                A future where physical products are as customizable and
                on-demand as digital ones — where anyone can own a piece of
                design that was, until recently, only possible to see on a screen.
              </p>
            </div>
          </div>
        </section>

        <section className="about-section">
          <h2>Contact</h2>
          <div className="contact-block">
            <div><span>Email:</span> hello@3dfilaspace.com</div>
            <div><span>Instagram:</span> @3dfilaspace</div>
            <div><span>Location:</span> Bengaluru, India</div>
          </div>
        </section>
      </div>
    </>
  );
}